import type { AxialCoord } from '../math/HexMath';

export const enum TravelMode {
  Normal = 0,
  Reveal = 1,
  Warp = 2,
}

export const enum TravelPhase {
  Idle = 0,
  SelectingStart = 1,
  SelectingEnd = 2,
  Pathfinding = 3,
  Traveling = 4,
  Arrived = 5,
}

export const enum WarpSegment {
  Warmup = 0,
  Warp = 1,
  Cooldown = 2,
}

export interface TravelHex {
  q: number;
  r: number;
}

export interface WarpRange {
  readonly startIdx: number;
  readonly endIdx: number;
}

export interface TravelRoute {
  readonly hexes: readonly AxialCoord[];
  readonly segmentDurations: Float32Array;
  readonly segmentKinds: Uint8Array;
  readonly totalSeconds: number;
  readonly warpRanges: readonly WarpRange[];
}

export interface AnimatorResult {
  worldX: number;
  worldZ: number;
  dirX: number;
  dirZ: number;
  /** Angular velocity in rad/s. Positive = turning right. */
  turnRate: number;
  hexQ: number;
  hexR: number;
  hopCompleted: boolean;
  finished: boolean;
}
